import { playUiSound, UiSound } from "../sound/uiSoundPlayer";

export type ButtonVariant = "primary" | "secondary" | "danger" | "ghost";

export function createButton(
	label: string,
	onClick: () => void,
	variant: ButtonVariant = "primary",
): HTMLButtonElement {
	const button = document.createElement("button");
	button.className = `btn btn-${variant}`;
	button.textContent = label;
	button.onclick = () => {
		playUiSound(UiSound.CLICK);
		onClick();
	};
	return button;
}
